import { jsx, jsxs } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { TextButton } from "@zillow/constellation-10";
import { IconChevronLeftOutline } from "@zillow/constellation-icons";
import { yieldCallback } from "@zillow/yield-callback";
import "react";
import { useCurrentUser } from "../../hooks/user.esm.js";
import { getCmsInfoForPage } from "../../utils/clickstream/getCmsInfoForPage.esm.js";
import { sendEvent } from "./B2BUserNav.utils.esm.js";
import SignIn from "./SignIn.esm.js";
import { usePageProps } from "@zillow/cms-utils";
const outerStyles = css({
  position: "relative",
  borderBottom: "1px solid",
  borderBottomColor: "border.muted",
  xlDown: {
    position: "relative",
    height: "auto",
    width: "100%"
  }
});
const outerDefaultBg = css({
  background: "bg.neutral"
});
const outerTransparentBg = css({
  background: "rgba(0, 0, 0, 0)"
});
const innerStyles = css({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  maxWidth: "1280px",
  margin: "0 auto",
  paddingBlock: "tighter",
  paddingInline: "default"
});
const leftSectionStyles = css({
  display: "flex",
  alignItems: "center",
  gap: "tighter"
});
const B2BUserNav = (props) => {
  const {
    env,
    redirectParam,
    router,
    signInLink,
    transparent,
    userMenuItems
  } = props;
  const pageProps = usePageProps();
  const cmsInfo = getCmsInfoForPage(pageProps);
  const {
    data: {
      user
    }
  } = useCurrentUser();
  return /* @__PURE__ */ jsx("div", { "data-testid": "b2b-user-nav", role: "navigation", "aria-label": "B2B User Navigation", className: `${outerStyles} ${transparent ? outerTransparentBg : outerDefaultBg}`, children: /* @__PURE__ */ jsxs("div", { className: innerStyles, children: [
    /* @__PURE__ */ jsx("div", { className: leftSectionStyles, children: /* @__PURE__ */ jsx(TextButton, { tone: "subtle", onImpact: transparent, textStyle: "body-sm", icon: /* @__PURE__ */ jsx(IconChevronLeftOutline, {}), asChild: true, children: /* @__PURE__ */ jsx("a", { href: "/", onClick: yieldCallback(() => {
      sendEvent("cms_anchor", "Zillow Home", "https://www.zillow.com/", cmsInfo);
    }), children: "Zillow Home" }) }) }),
    signInLink && /* @__PURE__ */ jsx(SignIn, { user, inverse: transparent, signInLink, redirectParam, router, env, userMenuItems })
  ] }) });
};
export {
  B2BUserNav as default
};
